<template>
    <div
        class="cabinet-table-options-pagination flex flex-justify-sb flex-align-center"
        :class="classes"
    >
        <a
            href="javascript:void(0)"
            class="cabinet-table-options-pagination__prev disabled"
            :class="{ disabled: currentPage <= 1 }"
            @click.prevent="onPrev"
        ></a>
        <div class="cabinet-table-options-pagination__pages">
            <input
                type="number"
                :min="1"
                :max="totalProducts"
                :value="currentPage"
                class="cabinet-table-options-pagination__input"
                @input="onInput"
            />
            /
            <span class="cabinet-table-options-pagination__all">
                {{ totalPages }}
            </span>
        </div>
        <a
            href="javascript:void(0)"
            class="cabinet-table-options-pagination__next"
            :class="{ disabled: currentPage >= totalPages }"
            @click.prevent="onNext"
        ></a>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'TablePagination',
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        totalPages: {
            type: Number,
            default: 1
        },
        totalProducts: {
            type: Number,
            default: 1
        },
        classes: {
            // eslint-disable-next-line
            type: Array | Object,
            default: function() {
                return []
            }
        },
        disableScrollTop: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        currentPage: function(val) {
            if (this.disableScrollTop) return
            this.$nextTick(() => {
                setTimeout(() => {
                    this.scrollTop()
                }, 800)
            })
        }
    },
    methods: {
        onInput: _.debounce(function(e) {
            let page = parseInt(e.target.value)
            if (!page || page < 1 || page > this.totalPages) return

            this.$emit('setPage', page)
        }, 900),
        onPrev() {
            let prevPage = this.currentPage - 1
            if (prevPage <= 0) return

            this.$emit('setPage', prevPage)
        },
        onNext() {
            let nexPage = this.currentPage + 1
            if (nexPage > this.totalPages) return

            this.$emit('setPage', nexPage)
        },
        scrollTop() {
            window.$('html, body').animate({ scrollTop: 0 }, 'slow')
        }
    }
}
</script>
